function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM from 'react-dom';
import { WDHComponent } from '../../../../../../../wdh-foundation/wdh';

/**
 * @memberOf module:wdh-Shop-Navigation
 */
var WDHDynamicShopNavigation = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHDynamicShopNavigation() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'shop-dynamic-navigation-menu';
    _classCallCheck(this, WDHDynamicShopNavigation);
    return _callSuper(this, WDHDynamicShopNavigation, [className]);
  }
  _inherits(WDHDynamicShopNavigation, _WDHComponent);
  return _createClass(WDHDynamicShopNavigation, [{
    key: "init",
    value: function init(component) {
      if (component.querySelector('.shop-dynamic-navigation-menu .dynamic-menu-for-shop') !== null) {
        ReactDOM.render(/*#__PURE__*/React.createElement(DynamicShopNavigation, null), component.querySelector('.shop-dynamic-navigation-menu .dynamic-menu-for-shop'));
      }
      // silently fail otherwise
    }
  }, {
    key: "resize",
    value: function resize(component) {}
  }, {
    key: "scroll",
    value: function scroll(component) {}
  }]);
}(WDHComponent);
export default WDHDynamicShopNavigation;
var EventBus = window.DGS.Event.getInstance();
var DynamicShopNavigation = /*#__PURE__*/function (_React$Component) {
  function DynamicShopNavigation(props) {
    var _this;
    _classCallCheck(this, DynamicShopNavigation);
    _this = _callSuper(this, DynamicShopNavigation, [props]);
    // set initial state for expiring week value
    _this.state = {
      data: [],
      width: window.innerWidth
    };
    return _this;
  }
  _inherits(DynamicShopNavigation, _React$Component);
  return _createClass(DynamicShopNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getDynamicNavItems();
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      window.addEventListener('resize', this.handleWindowSizeChange.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowSizeChange.bind(this));
    }
  }, {
    key: "handleWindowSizeChange",
    value: function handleWindowSizeChange() {
      this.setState({
        width: window.innerWidth
      });
    }
  }, {
    key: "getDynamicNavItems",
    value: function getDynamicNavItems() {
      var _this2 = this;
      EventBus.on('ADD_MENUITEMS', function (data) {
        _this2.setState({
          data: data.menuItems
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var width = this.state.width;
      var isMobile = width <= 1023;
      if (isMobile) {
        return /*#__PURE__*/React.createElement("div", {
          className: "mobile-only"
        }, /*#__PURE__*/React.createElement("h3", {
          className: "no-border"
        }, "Browse by category"), this.state.data.map(function (dynamicMenuHeader, index) {
          return /*#__PURE__*/React.createElement("p", {
            key: index
          }, /*#__PURE__*/React.createElement("a", {
            href: dynamicMenuHeader.url
          }, dynamicMenuHeader.title));
        }));
      } else {
        return /*#__PURE__*/React.createElement("div", null, this.state.data.map(function (dynamicMenuHeader, index) {
          return /*#__PURE__*/React.createElement("div", {
            className: "submenu-column",
            key: index
          }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("a", {
            href: dynamicMenuHeader.url
          }, dynamicMenuHeader.title)), dynamicMenuHeader.menuItems.map(function (dynamicSubContent, index) {
            return /*#__PURE__*/React.createElement("p", {
              key: index
            }, /*#__PURE__*/React.createElement("a", {
              href: dynamicSubContent.url
            }, dynamicSubContent.title));
          }));
        }));
      }
    }
  }]);
}(React.Component);